function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "a",
  points: "5553 0 0 0 0 406 5394.5 406"
}), React.createElement("polygon", {
  id: "c",
  points: "159 2.81719092e-15 6096 0 6096 406 0.5 406"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(0.000000, -14.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, -14.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, 4.000000)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("g", {
  mask: "url(#b)",
  fill: "#BFE5E5"
}, React.createElement("g", {
  transform: "translate(0.000000, 28.000000)"
}, React.createElement("rect", {
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 28,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 56,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 84,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 112,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 140,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 168,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 196,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 224,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 252,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 280,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 308,
  width: 6320,
  height: 14
}), React.createElement("rect", {
  y: 336,
  width: 6320,
  height: 14
})))), React.createElement("g", {
  transform: "translate(5394.000000, 0.000000)"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#c"
})), React.createElement("g", {
  mask: "url(#d)"
}, React.createElement("g", {
  transform: "translate(-223.000000, 0.000000)"
}, React.createElement("g", {
  className: "rightLines"
}, React.createElement("rect", {
  fill: "#BFE5E5",
  y: 28,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 56,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 84,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 112,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 140,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 168,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 196,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 224,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 252,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 280,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 308,
  width: 6319,
  height: 14
}), React.createElement("rect", {
  fill: "#BFE5E5",
  y: 336,
  width: 6319,
  height: 14
}))))))));

var SvgHeader = function SvgHeader(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 11490,
    height: 354,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Header.c6f77167.svg";
export { ForwardRef as ReactComponent };